
import './AODesription.scss';

import { Button, FormControlLabel, Radio, RadioGroup, ThemeProvider, Tooltip } from '@mui/material';
//import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import HeaderAoDescription from '../../../Components/shared/HeaderAoDescription';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchExpertDossierCandidat from '../../../Components/shared/SearchExpertDossierCandidat';
import { typeExperts } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useFormValidation from '../../../hooks/useFormValidation';
import useGetRequest from '../../../hooks/useGetRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';

function PostulateToAO() {
    const { setShowErrors, setErrors } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    let param = useParams();
    const [tjPrevoi, setTjPrevoi] = useState('');
    const [motivation, setMotivation] = useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const {setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const role=useRole();
    //TODO
    const [dateDisponibilite, setDateDisponibilite] = useState({ type: 'immediate', date: null });
    const { inputSize } = useWindowSize();
    const [visiblImmediate, setVisibleImmediate] = useState(true);
    const { data: ao } = useGetRequest({ url: `/ao/getAObyId/${param?.AOid}` });
    const navigate = useNavigate();
    const [expert,setExpert]=useState();
    console.log('expert',expert);
    const [isDossierCandidat ,setIsDossierCandidat]=useState(false);
    const [isValid] = useFormValidation([
        { name: 'tjPrevoi', value: tjPrevoi },
        { name: 'dateDisponibilite', value: dateDisponibilite },
    ]);
    const postulate = async () => {
        try {
            // payload is an object {key:value}
            const response = await axiosPrivate.post('/candidature/postulate/' + ao?.AO?._id,
                { tjPrevoi, dateDisponibilite, motivation,...(role === 'esn' ? { expertIdTarget: expert?._id } : {}) });
            if (response) {
                if(role=='esn')
                    navigate(`/${role}/aosHTH`, {});
                else
                    navigate(`/${role}/`, {});
                Swal.fire({
                    icon: 'success',
                    confirmButtonColor: '#5CC889',
                    text: i18n.t('Votre candidature a été envoyée avec succès!'),
                    confirmButtonText: 'Ok',
                });
            }
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
            //* to make sure it's a string
            setSnackBarMessage(error.response?.data.error+'');
            setOpenSnackBar(true);
        }
    };

    return (
        <form className='HomeDesc'>
            <div className='frame5Profile'>
                {role=='esn'? i18n.t('Appels d\'offres HTH') :i18n.t('Appels d\'offres')} &gt; {i18n.t('Rechercher un AO')} &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                    {i18n.t('Répondre à l\'appel d\'offres')}
                </span>
            </div>
            <HeaderAoDescription
                ao={ao?.AO}
                typeAction={'postulate'}
            />
            <div className='Frame3'>
                <h4 className='titlesociete'>
                    {i18n.t('Candidature à l\'appel d\'offres')}
                </h4>
            </div>

            {role=='esn' &&
                <div className='CandidatureFrame1'>
                    <div className='CandidatureFrame2'>
                        <h6 className='CandidatureF2Title'>
                            {i18n.t('Sélectionner un Expert ou dossier Candidat')}
                        </h6>
                        <div className='CandidatureFrame3'>
                            <div className='CandidatureFrame31'>
                                <SelectComponent
                                    setVal={(e) => {
                                        setIsDossierCandidat(e.target.value);
                                    }}
                                    val={isDossierCandidat}
                                    listVal={typeExperts}
                                />
                                {/* getMyExperts?isDossierCandidat */}
                                <SearchExpertDossierCandidat
                                    width={'100%'}
                                    isDossierCandidat={isDossierCandidat=='candidat' ? true : false}
                                    ajouterDossierCandidat={isDossierCandidat=='candidat' ? true : false}
                                    // name={selectedType}
                                    setUser={setExpert}

                                />

                            </div>

                        </div>
                    </div>
                </div>
            }
            <div className='CandidatureFrame1'>
                <div className='CandidatureFrame2'>
                    <h6 className='CandidatureF2Title'>
                        {i18n.t('Taux journalier et Disponibilité')}
                    </h6>
                    <div className='CandidatureFrame3'>
                        <div className='CandidatureFrame31'>
                            <p className='CandidatureF31Title'>
                                {i18n.t('TJ souhaité percevoir')}
                            </p>
                            <IconTextField
                                type="number"
                                // min={0}
                                inputProps={{ min: 0 }} //* max
                                iconEnd={'€'}
                                //InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>) }}
                                placeholder={i18n.t('00/jour')}
                                name="tjPrevoi"
                                style={{ width: device=='desktop'?'70%':'100%' }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                onChange={(e) => setTjPrevoi(e.target.value)}
                            />
                        </div>
                        <div className='selector1'>
                            <h6
                                className='nomPrenomProfile'
                                style={{ width: device=='desktop'?'30%':'100%' }}
                            >{i18n.t('Disponibilité')}</h6>
                            <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', gap: '8px', width: device=='desktop'?'70%':'100%' }}>
                                <RadioGroup
                                    value={dateDisponibilite.type}
                                    style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', gap: '8px', alignSelf: 'stretch', width: device=='desktop'?'50%':'100%' }}
                                    onChange={(e) => {
                                        if (e.target.value == 'aSpecifier') {
                                            setDateDisponibilite({ ...dateDisponibilite, type: e.target.value });
                                            setVisibleImmediate(false);
                                        }
                                        else {
                                            setDateDisponibilite({ type: e.target.value, date: null });
                                            setVisibleImmediate(true);
                                        }
                                    }}
                                >
                                    <div
                                        style={{
                                            boxSizing: 'border-box',
                                            alignItems: 'center',
                                            //height: '40px',
                                            padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                            height: inputSize == 'small' ? '40px' : '56px',
                                            gap: '4px',
                                            width:device=='desktop'?'49%':'100%',
                                            background: '#FFFFFF',
                                            border: '1px solid #9D9E9F',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <FormControlLabel
                                                value="immediate"
                                                control={<Radio />}
                                                label={i18n.t('Immédiate')}
                                            />
                                        </ThemeProvider>
                                    </div>
                                    <div
                                        style={{
                                            boxSizing: 'border-box',
                                            padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                            gap: '4px',
                                            height: inputSize == 'small' ? '40px' : '56px',
                                            whiteSpace: 'nowrap',
                                            width: device=='desktop'?'48%':'100%',
                                            background: '#FFFFFF',
                                            border: '1px solid #9D9E9F',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <FormControlLabel
                                                value="aSpecifier"
                                                control={<Radio />}
                                                label={i18n.t('En une date')}
                                            />
                                        </ThemeProvider>
                                    </div>
                                </RadioGroup>
                                <DatePickerComponent
                                    className="col-auto"
                                    label=""
                                    date={dateDisponibilite.date}
                                    disabled={visiblImmediate ? true : false}
                                    setDate={(newValue) => {
                                        setDateDisponibilite({ ...dateDisponibilite, date: newValue});
                                    }}
                                    disablePast
                                    width={device=='desktop'?'50%':'100%'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='FramePresMotiv'>
                <h4 className='titlesociete'>
                    {i18n.t('Présentation et motivation (recommandé)')}
                </h4>
            </div>
            <div className='FramePresMotivC'>
                <TextFieldComponent
                    placeholder={i18n.t('Expliquez en quoi votre candidature est pertinente pour répondre à cet appel d\'offres.')}
                    multiline
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    onChange={(e) => {
                        setMotivation(e.target.value);
                    }}
                    value={motivation}
                    style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                    rows={6}
                    maxRows={100}
                />
            </div>
            <div className='BtnValidation'>
                <Tooltip title={ao?.isExpertAlreadyPostulate ? i18n.t('vous avez déjà postulé à cet appel d\'offres') : ''}>
                    <span style={{width:'100%'}}>
                        <Button
                            variant="contained"
                            type='submit'
                            onClick={(e) => {
                                e.preventDefault();
                                if (isValid) {
                                    postulate();
                                    setShowErrors(false);
                                    setErrors({});
                                }
                                else setShowErrors(true);
                            }}
                            disabled={ao?.isExpertAlreadyPostulate}
                            style={{ ...buttonStylesGreen(ao?.isExpertAlreadyPostulate), ...{ width: device=='desktop'?'233px':'100%' } }}
                        >
                            {i18n.t('Valider la proposition')}
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </form>
    );
}

export default PostulateToAO;
